import { ref, computed, watch, h, onMounted, nextTick } from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  NDataTable,
  NInputNumber,
  NInput,
  NButton,
  NDatePicker,
  NSelect,
  NRadioGroup,
  NRadioButton,
  FormInst,
  FormRules,
  useMessage,
  useNotification,
  useDialog,
} from "naive-ui";
import { getCallable } from "@/config/env";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import { Product } from "@/model/product";
import { Organization } from "@/model/organization";
import { Order, OrderItem } from "@/model/order";

export function getQuotationStatusString(status: string) {
  if (status === constant.quotationStatus.PENDING) {
    return "수락 대기중";
  } else if (status === constant.quotationStatus.APPROVED) {
    return "수락 됨";
  } else {
    return "알수 없음";
  }
}

export function getOrderStatusString(status: string) {
  if (status === constant.orderStatus.PENDING) {
    return "견적 승인 대기 중";
  } else if (status === constant.orderStatus.APPROVED) {
    return "진단검사 정보입력 대기 중";
  } else if (status === constant.orderStatus.APPROVED_TEMP_SAVE) {
    return "진단검사 정보입력 임시저장 됨";
  } else if (status === constant.orderStatus.READY) {
    return "진단검사 실시 대기 중";
  } else if (status === constant.orderStatus.ING) {
    return "진단검사 실시 중";
  } else if (status === constant.orderStatus.REJECTED) {
    return "진담검사 승인거절 됨";
  } else if (status === constant.orderStatus.CANCELED) {
    return "진단검사 취소 됨";
  } else if (status === constant.orderStatus.COMPLETED) {
    return "진단검사 종료";
  } else {
    return "알수 없음";
  }
}

export function getPurchaseStatusString(status: string) {
  if (status === constant.orderStatus.PENDING) {
    return "승인 대기";
  } else if (
    status === constant.orderStatus.APPROVED ||
    status === constant.orderStatus.APPROVED_TEMP_SAVE ||
    status === constant.orderStatus.READY ||
    status === constant.orderStatus.ING ||
    status === constant.orderStatus.COMPLETED
  ) {
    return "구매 완료";
  } else if (
    status === constant.orderStatus.REJECTED ||
    status === constant.orderStatus.CANCELED
  ) {
    return "구매 취소";
  } else {
    return "알수 없음";
  }
}

export function getProjectStatusString(status: string) {
  if (status === constant.projectStatus.PENDING) {
    return "진단검사 실시 대기 중";
  } else if (status === constant.projectStatus.ING) {
    return "진단검사 실시 중";
  } else if (status === constant.projectStatus.COMPLETED) {
    return "진단검사 완료";
  } else if (status === constant.projectStatus.CANCELED) {
    return "진단검사 취소";
  } else {
    return "미정";
  }
}

export function useOrderForm() {
  const router = useRouter();
  const route = useRoute();
  const message = useMessage();
  const notification = useNotification();
  const dialog = useDialog();

  const pageLoading = ref(true);
  const orderFormRef = ref<FormInst | null>(null);

  const formModel = ref<Order>({
    order_id: "",
    SK: "",
    name: "",
    cc: "",
    receiver_email: "",
    client: {
      uid: "",
      name: "",
    },
    payment_method: {
      bank_date: null,
      bank_name: "",
      deposit_name: "",
      type: "",
    },
    products: [], // 견적 항목 배열
    status: "",
    totalPrice: 0,
    type: constant.orderType.BODY,
  });

  return {
    pageLoading,
    orderFormRef,
    formModel,
  };
}
